import { Injectable, signal } from '@angular/core';
import { ApiCallsService } from './network/api-calls.service';
import { api } from 'src/app/utils/endpoints';
import { BehaviorSubject, Observable, catchError, forkJoin, map, of } from 'rxjs';
import * as CONSTANT from 'src/app/utils/constants';

@Injectable({
  providedIn: 'root'
})
export class CommonDataSharingService {

  private regionsList: any = [];
  rolesList: any = [];
  private categories: any = [];
  businessesList: any = [];
  private orderCancelReasons = [];
  private ticketCancelReasons = [];
  private assignedBusinessesList: any = [];
  generalBusinessPostingGroup: any = [];
  customerPostingGroup: any = [];
  public notificationHeader: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public notificationIsRead: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public notificationMarkAllRead: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  public notificationSidebarToHeader: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  
  constructor(private _apiCalls: ApiCallsService) { }

  getRegionsList(): Observable<any> {
    if (this.regionsList.length == 0) {
      return this._apiCalls.get(api._regions).pipe(map((res: any) => {
        this.regionsList = res.data.data.map((x: any) => { return { id: x.name, name: x.name, sId: x.name } });
        return this.regionsList;
      }))
    } else {
      return of(this.regionsList);
    }
  }

  getRolesList() {
    if (this.rolesList.length == 0) {
      this._apiCalls.get(api._roles).subscribe(({
        next: (res: any) => {
          this.rolesList = res.data.data;
        },
        error: (error: any) => console.log(error)
      }))
    }
  }

  getCategoriesSubCategories(usedFor?: any): Observable<any> {
    return this._apiCalls.get(api._categories).pipe(map((res: any) => {
      // Filter out categories with no subcategories
      const filtered = res.data.rows.filter((category: any) => category.subcategories && category.subcategories.length > 0);

      // Map to include subcategories as `children`
      this.categories = filtered.map(({ subcategories, ...rest }: any) => ({
        ...rest,
        children: subcategories
      }));

      if(usedFor === 'inventory')
        this.categories.push({ name: 'Status', type: "inventoryStatus", children: this._modifyInventoryStatuses }) 
      
      if(usedFor === 'category')
        this.categories.push({ name: 'Creation Date', type: "dateRange", children: this._modifyDatesFilter }) 

      console.log(this.categories);
      return this.categories;
    }));  

    // if (this.categories.length == 0) {
    //   return this._apiCalls.get(api._categories).pipe(map((res: any) => {
    //     this.categories = res.data.rows.map(({ subcategories, ...rest }: any) => ({ ...rest, children: subcategories }));
    //     console.log(this.categories);
    //     return this.categories;
    //   }));
    // } else {
    //   return of(this.categories);
    // }
  }

  private get _modifyInventoryStatuses(): any {
    const inventoryStatus = CONSTANT._clone(CONSTANT.inventoryFilterStatus);
    return Object.entries(inventoryStatus).map(([id, name]) => ({ id: name, name: name, sId: id }));
  }

  _getBusinessesList(): Observable<any> {
    // this._apiCalls.get(api._businessUser, '').subscribe({
    //   next: (res: any) => this.businessesList = res.data.rows,
    //   error: (err: any) => console.log(err)
    // })
    if (this.businessesList.length == 0) {
      return this._apiCalls.get(api._businessUser).pipe(map((res: any) => {
        this.businessesList = res.data.rows;
        return this.businessesList;
      }))
    } else {
      return of(this.businessesList);
    }
  }

  _getGeneralBusinessPostingGroup(): Observable<any> {
    if (this.generalBusinessPostingGroup.length == 0) {
      const request: any = {'groupName': 'genBusPostingGroup'};
      return this._apiCalls.get(api._getBusinessCentralList, request).pipe(map((res: any) => {
        this.generalBusinessPostingGroup = res.data.rows;
        return this.generalBusinessPostingGroup;
      }))
    } else {
      return of(this.generalBusinessPostingGroup);
    }
  }

  _getCustomerPostingGroup(): Observable<any> {
    if (this.customerPostingGroup.length == 0) {
      const request: any = {'groupName': 'custPostingGroup'};
      return this._apiCalls.get(api._getBusinessCentralList, request).pipe(map((res: any) => {
        this.customerPostingGroup = res.data.rows;
        return this.customerPostingGroup;
      }))
    } else {
      return of(this.customerPostingGroup);
    }
  }

  getOrderCancelReasonsList(): Observable<any> {
    if (this.orderCancelReasons.length == 0) {
      return this._apiCalls.get(api._cancelOrderReasons).pipe(map((res: any) => {
        this.orderCancelReasons = res.data;
        return this.orderCancelReasons;
      }))
    } else {
      return of(this.orderCancelReasons);
    }
  }

  getTicketCancelReasonsList(): Observable<any> {
    if (this.ticketCancelReasons.length == 0) {
      let data = {type:5,platform:1}
      return this._apiCalls.get(api._cancelTicket, data).pipe(map((res: any) => {
        this.ticketCancelReasons = res.data;
        return this.ticketCancelReasons;
      }))
    } else {
      return of(this.ticketCancelReasons);
    }
  }

  getAssignedBusinessesList(): Observable<any> {
    if (this.assignedBusinessesList.length == 0) {
      return this._apiCalls.get(api._assignedBusinessesList).pipe(map((res: any) => {
        this.assignedBusinessesList = res.data.rows;
        return this.assignedBusinessesList;
      }))
    } else {
      return of(this.assignedBusinessesList);
    }
  }

  getPickupFilters(): Observable<any> {
    return forkJoin({
      status: of(this._modifyPickStatuses), dates: of(this._modifyDatesFilter),
    }).pipe(map(({ status, dates }) => [{ name: 'Status', children: status }, { name: 'Date', type: "dateRange", children: dates },
    ]), catchError((err: any) => []));
  }

  getInvoiceFilters(): Observable<any> {
    return forkJoin({
      status: of(this._modifyInvoiceStatuses), 
      dates: of(this._modifyDatesFilter),
    }).pipe(map(({ status, dates }) => [
      // { name: 'Status', children: status }, 
      { name: 'Date', type: "dateRange", children: dates },
    ]), catchError((err: any) => []));
  }

  private get _modifyPickStatuses(): any {
    const pickupStatuses = CONSTANT._clone(CONSTANT.pickupStatuses);
    return Object.entries(pickupStatuses).map(([id, name]) => ({ id: name, name: name, sId: id }));
  }

  private get _modifyInvoiceStatuses(): any {
    const invoiceStatus = CONSTANT._clone(CONSTANT.invoiceStatus);
    return Object.entries(invoiceStatus).map(([id, name]) => ({ id: name, name: name, sId: id }));
  }

  private get _modifyBusinessesStatuses(): any {
    const businessStatus = CONSTANT._clone(CONSTANT.statusDatas);
    return Object.entries(businessStatus).map(([id, name]) => ({ id: name, name: name, sId: id }));
  }

  private get _modifyBusinessesTypes(): any {
    const businessTypes = CONSTANT._clone(CONSTANT.businessTypes);
    return Object.entries(businessTypes).map(([id, name]) => ({ id: name, name: name, sId: id }));
  }

  private get _modifyOrderStatuses(): any {
    const orderStatues = CONSTANT._clone(CONSTANT.orderStatuses);
    return Object.entries(orderStatues).map(([id, name]) => ({ id: name, name: name, sId: id }));
  }

  private get _modifyDatesFilter(): any {
    return CONSTANT.datesFilter;
  }

  private get _modifyDeliveryAgentStatuses(): any {
    const deliveryAgentsStatus = CONSTANT._clone(CONSTANT.deliveryAgentStatus);
    return Object.entries(deliveryAgentsStatus).map(([id, name]) => ({ id: name, name: name, sId: id }));
  }

  private get _modifyDeliveryAgentOrdersStatuses(): any {
    const orderStatues = CONSTANT._clone(CONSTANT.deliveryAgentOrderStatuses);
    return Object.entries(orderStatues).map(([id, name]) => ({ id: name, name: name, sId: id }));
  }

  private get _modifyDeliveryAgentOrdersHistoryStatuses(): any {
    const orderStatues = CONSTANT._clone(CONSTANT.deliveryAgentOrderHistoryStatuses);
    return Object.entries(orderStatues).map(([id, name]) => ({ id: name, name: name, sId: id }));
  }

  private get _modifyUsersStatuses(): any {
    const usersStatuses = CONSTANT._clone(CONSTANT.userStatuses);
    return Object.entries(usersStatuses).map(([id, name]) => ({ id: name, name: name, sId: id }));
  }

  private get _modifyQuotationStatuses(): any {
    const quotationStatus = CONSTANT._clone(CONSTANT.quotationStatuses);
    return Object.entries(quotationStatus).map(([id, name]) => ({ id: name, name: name, sId: id }));
  }

  private get _modifyTicketReplacementStatuses(): any {
    const ticketReplacementStatuses = CONSTANT._clone(CONSTANT.ticketReplacementStatuses);
    return Object.entries(ticketReplacementStatuses).map(([id, name]) => ({ id: name, name: name, sId: id }));
  }

  private get _modifyDeliveryAgentPickupsStatuses(): any {
    const orderStatues = CONSTANT._clone(CONSTANT.deliveryAgentPickupsStatuses);
    return Object.entries(orderStatues).map(([id, name]) => ({ id: name, name: name, sId: id }));
  }

  private get _modifyDeliveryAgentPickupsHistoryStatuses(): any {
    const orderStatues = CONSTANT._clone(CONSTANT.deliveryAgentPickupsHistoryStatuses);
    return Object.entries(orderStatues).map(([id, name]) => ({ id: name, name: name, sId: id }));
  }

  private get _modifyGeneralTicketStatuses(): any {
    const ticketGeneralStatuses = CONSTANT._clone(CONSTANT.ticketGeneralStatuses);
    return Object.entries(ticketGeneralStatuses).map(([id, name]) => ({ id: name, name: name, sId: id }));
  }

  getBusinessesFilters(): any {
    return forkJoin({
      regions: this.getRegionsList(),
      status: of(this._modifyBusinessesStatuses), types: of(this._modifyBusinessesTypes),
    }).pipe(map(({ regions, status, types }) => [{ name: 'Region', children: regions },
    { name: 'Status', children: status }, { name: 'Type', children: types },
    ]), catchError((err: any) => []));
  }

  getOrdersFilters(ordersType: any): Observable<any> {
    if (ordersType == 'ordersListing') {
      return forkJoin({
        regions: this.getRegionsList(),
        status: of(this._modifyOrderStatuses), dates: of(this._modifyDatesFilter),
      }).pipe(map(({ regions, status, dates }) => [{ name: 'Region', children: regions },
      { name: 'Status', children: status }, { name: 'Expected Delivery Date', type: "dateRange", children: dates },
      ]), catchError((err: any) => []));
    }
    if (ordersType == 'orders') {
      return of([{ name: 'Status', children: this._modifyDeliveryAgentOrdersStatuses }, { name: 'Expected Delivery Date', type: "dateRange", children: this._modifyDatesFilter }]);
    }
    if (ordersType == 'pickups') {
      return of([{ name: 'Status', children: this._modifyDeliveryAgentPickupsStatuses }, { name: 'Date', type: "dateRange", children: this._modifyDatesFilter }]);
    }
    if (ordersType == 'pickups-history') {
      return of([{ name: 'Status', children: this._modifyDeliveryAgentPickupsHistoryStatuses }, { name: 'Date', type: "dateRange", children: this._modifyDatesFilter }]);
    }
    if (ordersType == 'business-pickups') {
      return of([{ name: 'Status', children: this._modifyPickStatuses }, { name: 'Date', type: "dateRange", children: this._modifyDatesFilter }]);
    }
    return of([{ name: 'Status', children: this._modifyDeliveryAgentOrdersHistoryStatuses }, { name: 'Expected Delivery Date', type: "dateRange", children: this._modifyDatesFilter }]);
  }

  getDeliveryAgentsFilters(): any {
    return forkJoin({
      regions: this.getRegionsList(), status: of(this._modifyDeliveryAgentStatuses)
    }).pipe(map(({ regions, status }) => [{ name: 'Region', children: regions },
    { name: 'Status', children: status }
    ]), catchError((err: any) => []));
  }

  getUsersFilters(): any {
    return of([{ name: 'Status', children: this._modifyUsersStatuses }]);
  }

  getQuotationFilters(): Observable<any> {
    return forkJoin({
      status: of(this._modifyQuotationStatuses), dates: of(this._modifyDatesFilter),
    }).pipe(map(({ status, dates }) => [{ name: 'Status', children: status }, { name: 'Quotation Date', type: "dateRange", children: dates },
    ]), catchError((err: any) => []));
  }

  getReplacementTicketFilters(): Observable<any> {
    return forkJoin({
      status: of(this._modifyTicketReplacementStatuses), dates: of(this._modifyDatesFilter),
    }).pipe(map(({ status, dates }) => [{ name: 'Status', children: status }, { name: 'Ticket Date', type: "dateRange", children: dates },
    ]), catchError((err: any) => []));
  }

  getGeneralTicketFilters(): Observable<any> {
    return forkJoin({
      status: of(this._modifyGeneralTicketStatuses), dates: of(this._modifyDatesFilter),
    }).pipe(map(({ status, dates }) => [{ name: 'Status', children: status }, { name: 'Ticket Date', type: "dateRange", children: dates },
    ]), catchError((err: any) => []));
  }

  _getToggleNotification(tab?: any) {
    return this._apiCalls.getDataWithoutLoader(api._notification, { 'skip': 0, 'limit': 4, 'tab': tab })
  }

  _markAllAsRead() {
    return this._apiCalls.put(api._markRead, { 'isRead': 1 });
  }

  _getQuotationCount() {
    return this._apiCalls.get(api._quotationCount);
  }

  _markAsRead(id: any) {
    const request = {'id': id, 'isRead': 1}
    return this._apiCalls.putWithoutLoader(api._markRead, request);
  }
}
